let lib: any;
let listening: boolean = false;
let text: string = '';
let starting: boolean = false;
let lastError: string | null = null;
let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
let isIphone = /iPad|iPhone|iPod/.test(navigator.userAgent);
let interimMode = isSafari && !isIphone;

function load(language: string) {
  try {
    const { SpeechRecognition, webkitSpeechRecognition, mozSpeechRecognition, msSpeechRecognition }: any = window;
    
    if (!SpeechRecognition && !webkitSpeechRecognition && !mozSpeechRecognition && !msSpeechRecognition) {
      console.error('Speech Recognition API not supported in this browser');
      throw new Error('Speech Recognition API não suportada neste navegador');
    }
    
    lib = new (SpeechRecognition || webkitSpeechRecognition || mozSpeechRecognition || msSpeechRecognition)();
    lib.interimResults = interimMode;
    lib.maxAlternatives = 5;
    lib.lang = language;
    console.log('Speech Recognition loaded with language:', language);
  } catch (error) {
    console.error('Error loading recognition:', error);
    throw error;
  }
}

function rec(call?: any) {
  if (!lib) {
    throw new Error('Speech Recognition not initialized. Call recognition.load() first.');
  }
  lastError = null;
  text = '';

  function onresult({ results }: any) {
    text = interimMode ? results[results.length - 1][0].transcript : `${text} ${results[results.length - 1][0].transcript}`;
    if (!call) return;
    call(text)
  }

  function onend() {
    // Avoid infinite loops + "already started" errors on Safari by guarding restarts.
    if (!listening) {
      starting = false;
      return;
    }

    starting = false;
    try {
      starting = true;
      lib.start();
    } catch (e: any) {
      starting = false;
      // Safari throws InvalidStateError when already started; ignore and keep listening.
      if (String(e?.name || e?.message || '').toLowerCase().includes('invalidstate')) return;
      if (String(e?.message || '').toLowerCase().includes('already started')) return;
      console.error('Speech Recognition onend restart failed:', e);
    }
  }

  function onerror({ error }: any) {
    lastError = String(error || '');
    console.error('Speech Recognition error:', error);
    console.error('Error details:', {
      error: error,
      isAborted: error === 'aborted',
      isNotAllowed: error === 'not-allowed',
      isNoSpeech: error === 'no-speech',
      isAudioCapture: error === 'audio-capture',
      isNetwork: error === 'network',
      isServiceNotAllowed: error === 'service-not-allowed'
    });
  }

  listening = true;
  lib.onresult = onresult;
  lib.onend = onend;
  lib.onerror = onerror;

  // Ensure we aren't already started (Safari can get stuck).
  try {
    lib.stop();
    lib.abort();
  } catch (_) {}

  if (starting) return;
  starting = true;
  try {
    lib.start();
  } catch (e: any) {
    starting = false;
    // Safari throws InvalidStateError when already started; ignore.
    if (String(e?.name || e?.message || '').toLowerCase().includes('invalidstate')) return;
    if (String(e?.message || '').toLowerCase().includes('already started')) return;
    throw e;
  }
}

function stop() {
  listening = false;
  starting = false;
  // DON'T clear text here - caller needs to read it first via getText()

  if (!lib) return;
  try {
    lib.stop();
  } catch (_) {}
  try {
    lib.abort();
  } catch (_) {}
}

function clearText() {
  text = '';
  lastError = null;
}

const recognition = {
  load,
  rec,
  stop,
  getText: () => text,
  getLastError: () => lastError,
  clearText
};

export default recognition;